import { render, staticRenderFns } from "./ExcertoDecisao.vue?vue&type=template&id=3740485e&"
import script from "./ExcertoDecisao.vue?vue&type=script&lang=js&"
export * from "./ExcertoDecisao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports